var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("../../assets/images/logo.png"),"width":"110"}}),_c('nav'),_c('HeaderRightNav')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }